import { render, staticRenderFns } from "./LoadingLayout.vue?vue&type=template&id=4e385f07"
import script from "./LoadingLayout.vue?vue&type=script&lang=js"
export * from "./LoadingLayout.vue?vue&type=script&lang=js"
import style0 from "./LoadingLayout.vue?vue&type=style&index=0&id=4e385f07&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports